/**
 * PillChip — kleiner Filter/Sort/Segment-Chip im Valeszka-Style.
 *
 * Merkmale:
 * - rounded-full pill
 * - uppercase tracking-wider text-[10px]
 * - klarer aktiv/inaktiv-Kontrast
 * - transition-colors
 *
 * Farbschemata (`variant`):
 *   - "neutral"  (default) — #0A0A0A / #E5E5E5 / #999  (Marketplace, Feed, Admin, Buyer-Flow)
 *   - "stx"     — stx-accent (Salmon)                  (nur STX-scoped)
 *   - "muted"   — kompakter Grau-Chip ohne Border      (Info-Tags)
 */
import { forwardRef } from "react";

const VARIANT_CLS = {
  neutral: {
    active:   "bg-[#0A0A0A] text-white border border-[#0A0A0A]",
    inactive: "bg-white text-[#666] border border-[#E5E5E5] hover:border-[#0A0A0A] hover:text-[#0A0A0A]",
  },
  stx: {
    active:   "bg-stx-accent text-stx-accent-fg border border-stx-accent",
    inactive: "bg-stx-panel text-stx-text-muted border border-stx-border hover:border-stx-accent hover:text-stx-accent",
  },
  muted: {
    active:   "bg-[#F5F5F5] text-[#0A0A0A] border border-[#E5E5E5]",
    inactive: "bg-white text-[#999] border border-[#E5E5E5] hover:text-[#0A0A0A]",
  },
};

const SIZE_CLS = {
  xs: "px-2 py-0.5 text-[9px]",
  sm: "px-2.5 py-1 text-[10px]",
  md: "px-3 py-1.5 text-[10px]",
  lg: "px-4 py-2 text-xs",
};

const PillChip = forwardRef(function PillChip(
  {
    active = false,
    disabled = false,
    variant = "neutral",
    size = "md",
    icon = null,
    children,
    onClick,
    testId,
    className = "",
    type = "button",
    ...rest
  },
  ref
) {
  const v = VARIANT_CLS[variant] || VARIANT_CLS.neutral;
  const sz = SIZE_CLS[size] || SIZE_CLS.md;
  return (
    <button
      ref={ref}
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      data-active={active ? "true" : "false"}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wider transition-colors shrink-0 disabled:opacity-40 disabled:cursor-not-allowed ${sz} ${active ? v.active : v.inactive} ${className}`}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
});

export default PillChip;
